import React, { Dispatch, useState } from 'react'
import { Input, Select } from '@alifd/next';
import $i18n from '@/i18n';
import styles from './index.module.less'

const Option = Select.Option;
const typeValueEmun = {
  ANDROID: 'Android',
  IOS: 'Ios'
}
const typeEmun = {
  Input: 'identifier',
  Select: 'type',
}

interface editablePane {
  type: 'Input' | 'Select'; record: any; setDataSource: Dispatch<any>; dataSource: any[]
}

const EditablePane: React.FC<editablePane> = ({ type, record, setDataSource, dataSource }) => {
  const [editable, setEditable] = useState(false);

  const onKeyDown = (e) => {
    const { keyCode } = e;
    // Stop bubble up the events of keyUp, keyDown, keyLeft, and keyRight
    if (keyCode > 36 && keyCode < 41) {
      e.stopPropagation();
    }
  }

  const onBlur = (e) => {
    const newDataSource = dataSource?.map(item => {
      if (item?.accessKey === record?.accessKey) {
        return { ...record, identifier: e.target.value?.trim() }
      }
      return item
    });
    setDataSource(newDataSource);
    setEditable(false);
  }

  const onClick = () => {
    if (!record?.[typeEmun?.[type]]) {
      setEditable(true)
    }
  }

  const selectOnChange = (value) => {
    const newDataSource = dataSource?.map(item => {
      if (item?.accessKey === record?.accessKey) {
        return { ...record, type: value }
      }
      return item
    });
    setDataSource(newDataSource);
  }

  const selectOnBlur = () => {
    setEditable(false)
  }

  if (editable) {
    if (type === 'Input') {
      return <Input autoFocus defaultValue={record?.[typeEmun?.[type]]} onKeyDown={onKeyDown} onBlur={onBlur} />
    } else {
      return <Select autoFocus defaultValue={record?.[typeEmun?.[type]]} onChange={selectOnChange} onBlur={selectOnBlur} >
        <Option value="ANDROID" >
          <div >
            <span role="img" style={{ marginRight: 4 }}>
              <span className="superapp_iconfont superapp_icon-anzhuo" style={{ fontSize: 12 }} />
            </span>
            {$i18n.get({
              id: 'aopf.pages.channel.setUpChannelCallerColumnsTypeOptionAndroid',
              dm: '安卓',
            })}
          </div>
        </Option>
        <Option value="IOS">
          <div >
            <span role="img" style={{ marginRight: 4 }}>
              <span className="superapp_iconfont superapp_icon-ios" />
            </span>
            {$i18n.get({
              id: 'aopf.pages.channel.setUpChannelCallerColumnsTypeOptionIos',
              dm: 'Ios',
            })}
          </div>
        </Option>
      </Select>
    }
  } else {
    return <div onClick={onClick} style={{ display: 'flex', alignItems: 'center' }}>
      {
        type === 'Input'
          ? record?.[typeEmun?.[type]] || $i18n.get({
            id: 'aopf.pages.channel.setUpChannelCallerColumnsCallerPlacehold',
            dm: '请输入调用方!',
          })
          : <>
            {record?.[typeEmun?.[type]] ?
              <>
                <span role="img" className={styles.callerIconContainer}>
                  {
                    record?.[typeEmun?.[type]] === 'ANDROID'
                      ? <span className="superapp_iconfont superapp_icon-anzhuo" style={{ fontSize: 12 }} />
                      : <span className="superapp_iconfont superapp_icon-ios" />
                  }
                </span>
                <span className={styles.title}>{typeValueEmun[record?.[typeEmun?.[type]]]}</span>
              </> :
              $i18n.get({
                id: 'aopf.pages.channel.setUpChannelTypeColumnsCallerPlacehold',
                dm: '请选择类别!',
              })
            }
          </>
      }
    </div >
  }
};
export default EditablePane;